module.exports = __webpack_public_path__ + "static/media/View-2.f8b19d23.webp";